import { render, staticRenderFns } from "./SimpleNavbar.vue?vue&type=template&id=17720faf&"
import script from "./SimpleNavbar.vue?vue&type=script&lang=js&"
export * from "./SimpleNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNavbar.vue?vue&type=style&index=0&id=17720faf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports